import { Switch, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

type Metric = { id: string; name: string; type: string };

export const MetricsSwitch = ({
  metricsOptions,
  selectedMetrics,
  setSelectedMetrics,
  disabled = false,
}: {
  metricsOptions: Metric[];
  selectedMetrics: Metric[];
  setSelectedMetrics: (metrics: Metric[]) => void;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const selectedMetricIds = selectedMetrics.map((m) => m.id);
  return (
    <div className="grid grid-cols-2 grid-rows-2">
      {metricsOptions.map((metric) => {
        const { id, name } = metric;
        const checked = selectedMetricIds.includes(id);
        return (
          <div className="flex flex-row gap-2 items-center mb-2" key={id}>
            <Switch
              disabled={disabled}
              size="small"
              checked={checked}
              onChange={(e) => {
                const checked = e.target.checked;
                if (checked) {
                  setSelectedMetrics([...selectedMetrics, metric]);
                } else {
                  setSelectedMetrics(
                    selectedMetrics.filter((m) => m.id !== id),
                  );
                }
              }}
              inputProps={{
                'aria-label': checked
                  ? t('unselectMetricName', { name })
                  : t('selectMetricName', { name }),
              }}
            />
            <Typography variant="body2">{name}</Typography>
          </div>
        );
      })}
    </div>
  );
};
